import React from 'react';
import { x } from '@xstyled/styled-components';
import { t } from 'ttag';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Flex } from '~/ui/flex/Flex';
import { ThumbsPages, useThumbsStore } from '../Store';

export const THANK_YOU_MESSAGE = () =>
  t`Thank you! Your feedback is very important to us.`;

export const ThankScreen = () => {
  const { page, toggle } = useThumbsStore();

  if (page !== ThumbsPages.ThankScreen) return null;

  return (
    <>
      <CloseButton sticky type="close" onClick={() => toggle(false)} />
      <Flex variant="list" gap="md">
        <x.div
          m="0px auto"
          p="10px 30px"
          maxWidth={{ _: '100%', md: '225px' }}
          textAlign="center"
          fontSize="18px"
          fontWeight="bold"
        >
          {THANK_YOU_MESSAGE()}
        </x.div>
      </Flex>
    </>
  );
};
